import { CATALOG_STATUS_DRAFT } from '../statuses/catalogStatus';
import { CATALOG_TYPE_MISSINGITEMS } from '../types/catalogTypes';

export const MISSING_ITEMS_CATALOG = {
  catalogId: CATALOG_TYPE_MISSINGITEMS,
  catalogType: CATALOG_TYPE_MISSINGITEMS,
  catalogName: 'Missing Items',
  catalogStatus: CATALOG_STATUS_DRAFT,
};
